import classNames from 'classnames';
import { ComponentProps } from 'react';
import { Button } from './Button';

export const PrimaryButton = ({
  className,
  ...props
}: ComponentProps<typeof Button>) => (
  <Button
    className={classNames(
      'disabled:bg-secondary-100',
      'disabled:text-secondary-400',
      'bg-primary-200',
      'hover:shadow-down-sm',
      'hover:bg-primary-300',
      'text-primary-800',
      'transition',
      'ease-in',
      'relative',
      'rounded-full',
      'py-2 px-4',
      'text-body-2-xl font-semibold font-geist',
      className
    )}
    type="submit"
    {...props}
  />
);
